<app-dashboard-container
	class="dashboard-se-ce-verschil"
	[factTable]="factTable"
	(doExport)="this.doExport(filterExpressions(),permanentExpressions(),$event)"
>
	<app-filter-panel
		[defaultFilters]="initialFilters"
		[allFilters]="allFilters()"
		(filterExpressionsChange)="filterExpressions.set($event)"
		endpoint="/cijfers"
		[permanentFilterExpressions]="permanentExpressions()"
	></app-filter-panel>
	<app-filter-bar [dataRootSelection]="dataRootSelection()"></app-filter-bar>
	<section class="dashboard">
		<app-dashboard-header>
			<div class="cl-header-subtitle">{{ getSchooljarenCaption() }}</div>
			<app-toggle-buttons [options]="varianten" [value]="variant()" (valueChange)="qp.dispatch('variant', $event)"></app-toggle-buttons>
			<app-schooljaar-indicator-over schooljaarFilterName="x_onderwijsresultaten_cf_schooljaar"></app-schooljaar-indicator-over>
			<app-onderwijsresultaten-uitsluiten-filter [isLeerlingen]="false"></app-onderwijsresultaten-uitsluiten-filter>
			<app-legenda class="cl-header-utility" [attribute]="['cf_fun_nr_cijferverschil_se_ce_afgerond']" [keyIsClassName]="true"></app-legenda>
		</app-dashboard-header>
		<app-barchart-table
			[filters]="filterExpressions()"
			[permanentFilters]="permanentExpressions()"
			[tableGroups]="table"
			[groups]="groups()"
			[config]="this"
		></app-barchart-table>
	</section>
</app-dashboard-container>
